import ShareableLinksMobile from './ShareableLinksMobile.component';

export default ShareableLinksMobile;